var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M8.77389 13.1617C8.66773 13.1617 8.57219 13.133 8.48726 13.0758C8.42357 12.9995 8.39172 12.9137 8.39172 12.8183L7.97771 0.343348C7.97771 0.247974 8.00955 0.171674 8.07325 0.114449C8.15817 0.0381498 8.25372 0 8.35987 0H12.086C12.1921 0 12.2771 0.0381498 12.3408 0.114449C12.4257 0.171674 12.4682 0.247974 12.4682 0.343348L11.9904 12.8183C11.9904 12.9137 11.948 12.9995 11.8631 13.0758C11.7994 13.133 11.7144 13.1617 11.6083 13.1617H8.77389ZM10.0159 20C9.29406 20 8.68896 19.7902 8.20064 19.3705C7.73355 18.9318 7.5 18.3882 7.5 17.7396C7.5 17.072 7.73355 16.5284 8.20064 16.1087C8.66773 15.6891 9.27282 15.4793 10.0159 15.4793C10.759 15.4793 11.3535 15.6891 11.7994 16.1087C12.2665 16.5284 12.5 17.072 12.5 17.7396C12.5 18.3882 12.2665 18.9318 11.7994 19.3705C11.3323 19.7902 10.7378 20 10.0159 20Z",
    fill: "#FF8484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlert);
export default __webpack_public_path__ + "static/media/SystemAlert.a5422c0c7d58c05b8e979bcb31b61737.svg";
export { ForwardRef as ReactComponent };